import { render, staticRenderFns } from "./ApplicationAdd.vue?vue&type=template&id=60a03e5b"
import script from "./ApplicationAdd.vue?vue&type=script&lang=js"
export * from "./ApplicationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports